import { v4 as uuidv4 } from "uuid";

//
import shaymatovChorikulIMG from "../images/shaymatovChorikul.jpg";
import mirzayevIlyosbekIMG from "../images/mirzayevIlyosbek.jpg";
import oripovOybekIMG from "../images/oripovOybek.jpg";
import atayevShuxratjonIMG from "../images/atayevShuxratjon.jpg";
import ganievSherzodIMG from "../images/ganievSherzod.jpg";
import oripovaYoqutxonIMG from "../images/oripovaYoqutxon.jpg";
import eshniyozovZarifjonIMG from "../images/eshniyozovZarifjon.jpg";
import xasanovJasurIMG from "../images/xasanovJasur.jpg";
import ibodullayevBektoshIMG from "../images/ibodullayevBektosh.jpg";

const list = [
  {
    id: 1,
    img: shaymatovChorikulIMG,
    imagePosition: "center 16%",
    imageScale: 1,
    name: "choriqulshaymatovName",
    specialist: "choriqulshaymatovSpec",
    socials: {
      facebook: "https://www.facebook.com/",
      instagram: "https://www.instagram.com/",
      twitter: "https://x.com/",
      telegram: "https://telegram.org/",
    },
    bio: "choriqulshaymatovBio",
    contact: {
      phone: "+998 (95) 410 00 14",
      mail: "choriqulshaymatov@gmail.com",
    },
    schedules: [
      {
        id: uuidv4(),
        title: "monday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "tuesday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "wednesday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "thursday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "friday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "saturday",
        time: "09.00-12.00",
      },
    ],
    degrees: [
      {
        id: uuidv4(),
        univer: "choriqulshaymatovUniver1",
        specialty: "choriqulshaymatovSpec1",
      },
      {
        id: uuidv4(),
        univer: "choriqulshaymatovUniver2",
        specialty: "choriqulshaymatovSpec2",
      },
      {
        id: uuidv4(),
        univer: "choriqulshaymatovUniver3",
        specialty: "choriqulshaymatovSpec3",
      },
      {
        id: uuidv4(),
        univer: "choriqulshaymatovUniver3",
        specialty: "choriqulshaymatovSpec4",
      },
      {
        id: uuidv4(),
        univer: "choriqulshaymatovUniver3",
        specialty: "choriqulshaymatovSpec5",
      },
      {
        id: uuidv4(),
        univer: "choriqulshaymatovUniver3",
        specialty: "choriqulshaymatovSpec6",
      },
    ],
    experience: ["choriqulshaymatovDegree1", "choriqulshaymatovDegree2"],
    awards: [
      "choriqulshaymatovAward1",
      "choriqulshaymatovAward2",
      "choriqulshaymatovAward3",
      "choriqulshaymatovAward4",
      "choriqulshaymatovAward5",
      "choriqulshaymatovAward6",
      "choriqulshaymatovAward7",
      "choriqulshaymatovAward8",
    ],
  },
  {
    id: 2,
    img: mirzayevIlyosbekIMG,
    imagePosition: "center 18%",
    imageScale: 1,
    name: "mirzaevilyosName",
    specialist: "mirzaevilyosSpec",
    socials: {
      facebook: "https://www.facebook.com/",
      instagram: "https://www.instagram.com/",
      twitter: "https://x.com/",
      telegram: "https://telegram.org/",
    },
    bio: "mirzaevilyosBio",
    contact: {
      phone: "+998 (95) 410 00 14",
      mail: "test@gmail.com",
    },
    schedules: [
      {
        id: uuidv4(),
        title: "monday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "tuesday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "wednesday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "thursday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "friday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "saturday",
        time: "09.00-12.00",
      },
    ],
    degrees: [
      {
        id: uuidv4(),
        univer: "mirzaevilyosUniver1",
        specialty: "mirzaevilyosSpec1",
      },
      {
        id: uuidv4(),
        univer: "mirzaevilyosUniver2",
        specialty: "mirzaevilyosSpec2",
      },
      {
        id: uuidv4(),
        univer: "mirzaevilyosUniver3",
        specialty: "mirzaevilyosSpec3",
      },
      {
        id: uuidv4(),
        univer: "mirzaevilyosUniver4",
        specialty: "mirzaevilyosSpec4",
      },
      {
        id: uuidv4(),
        univer: "mirzaevilyosUniver5",
        specialty: "mirzaevilyosSpec5",
      },
      {
        id: uuidv4(),
        univer: "mirzaevilyosUniver6",
        specialty: "mirzaevilyosSpec6",
      },
      {
        id: uuidv4(),
        univer: "mirzaevilyosUniver7",
        specialty: "mirzaevilyosSpec7",
      },
    ],
    experience: ["mirzaevilyosDegree1", "mirzaevilyosDegree2"],
    awards: [
      "mirzaevilyosAward1",
      "mirzaevilyosAward2",
      "mirzaevilyosAward3",
      "mirzaevilyosAward4",
    ],
  },
  {
    id: 5,
    img: oripovOybekIMG,
    imagePosition: "center 18%",
    imageScale: 1,
    name: "oripovOName",
    specialist: "oripovOSpec",
    socials: {
      facebook: "https://www.facebook.com/",
      instagram: "https://www.instagram.com/",
      twitter: "https://x.com/",
      telegram: "https://telegram.org/",
    },
    bio: "oripovOBio",
    contact: {
      phone: "+998 (95) 410 00 14",
      mail: "test@gmail.com",
    },
    schedules: [
      {
        id: uuidv4(),
        title: "monday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "tuesday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "wednesday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "thursday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "friday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "saturday",
        time: "09.00-12.00",
      },
    ],
    degrees: [
      {
        id: uuidv4(),
        univer: "oripovOUniver1",
        specialty: "oripovOSpec1",
      },
      {
        id: uuidv4(),
        univer: "oripovOUniver2",
        specialty: "oripovOSpec2",
      },
      {
        id: uuidv4(),
        univer: "oripovOUniver3",
        specialty: "oripovOSpec3",
      },
      {
        id: uuidv4(),
        univer: "oripovOUniver4",
        specialty: "oripovOSpec4",
      },
      {
        id: uuidv4(),
        univer: "oripovOUniver5",
        specialty: "oripovOSpec5",
      },
    ],
    experience: ["oripovODegree1", "oripovODegree2"],
    awards: [
      "oripovOAward1",
      "oripovOAward2",
      "oripovOAward3",
      "oripovOAward4",
    ],
  },
  {
    id: 3,
    img: atayevShuxratjonIMG,
    imagePosition: "center 16%",
    imageScale: 1,
    name: "atayevShName",
    specialist: "atayevShSpec",
    socials: {
      facebook: "https://www.facebook.com/",
      instagram: "https://www.instagram.com/",
      twitter: "https://x.com/",
      telegram: "https://telegram.org/",
    },
    bio: "atayevShBio",
    contact: {
      phone: "+998 (95) 410 00 14",
      mail: "test@gmail.com",
    },
    schedules: [
      {
        id: uuidv4(),
        title: "monday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "tuesday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "wednesday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "thursday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "friday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "saturday",
        time: "09.00-12.00",
      },
    ],
    degrees: [
      {
        id: uuidv4(),
        univer: "atayevShUniver1",
        specialty: "atayevShSpec1",
      },
      {
        id: uuidv4(),
        univer: "atayevShUniver2",
        specialty: "atayevShSpec2",
      },
      {
        id: uuidv4(),
        univer: "atayevShUniver3",
        specialty: "atayevShSpec3",
      },
      {
        id: uuidv4(),
        univer: "atayevShUniver4",
        specialty: "atayevShSpec4",
      },
      {
        id: uuidv4(),
        univer: "atayevShUniver5",
        specialty: "atayevShSpec5",
      },
    ],
    experience: ["atayevShDegree1", "atayevShDegree2"],
    awards: ["atayevShAward1", "atayevShAward2"],
  },
  {
    id: 4,
    img: ganievSherzodIMG,
    imagePosition: "center 18%",
    imageScale: 1,
    name: "ganievShName",
    specialist: "ganievShSpec",
    socials: {
      facebook: "https://www.facebook.com/",
      instagram: "https://www.instagram.com/",
      twitter: "https://x.com/",
      telegram: "https://telegram.org/",
    },
    bio: "ganievShBio",
    contact: {
      phone: "+998 (95) 410 00 14",
      mail: "test@gmail.com",
    },
    schedules: [
      {
        id: uuidv4(),
        title: "monday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "tuesday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "wednesday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "thursday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "friday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "saturday",
        time: "09.00-12.00",
      },
    ],
    degrees: [
      {
        id: uuidv4(),
        univer: "ganievShUniver1",
        specialty: "ganievShSpec1",
      },
      {
        id: uuidv4(),
        univer: "ganievShUniver2",
        specialty: "ganievShSpec2",
      },
      {
        id: uuidv4(),
        univer: "ganievShUniver3",
        specialty: "ganievShSpec3",
      },
      {
        id: uuidv4(),
        univer: "ganievShUniver4",
        specialty: "ganievShSpec4",
      },
    ],
    experience: ["ganievShDegree1", "ganievShDegree2"],
    awards: ["ganievShAward1", "ganievShAward2", "ganievShAward3"],
  },
  {
    id: 6,
    img: oripovaYoqutxonIMG,
    imagePosition: "center 16%",
    imageScale: 1,
    name: "oripovaYName",
    specialist: "oripovaYSpec",
    socials: {
      facebook: "https://www.facebook.com/",
      instagram: "https://www.instagram.com/",
      twitter: "https://x.com/",
      telegram: "https://telegram.org/",
    },
    bio: "oripovaYBio",
    contact: {
      phone: "+998 (95) 410 00 14",
      mail: "test@gmail.com",
    },
    schedules: [
      {
        id: uuidv4(),
        title: "monday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "tuesday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "wednesday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "thursday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "friday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "saturday",
        time: "09.00-12.00",
      },
    ],
    degrees: [
      {
        id: uuidv4(),
        univer: "oripovaYUniver1",
        specialty: "oripovaYSpec1",
      },
      {
        id: uuidv4(),
        univer: "oripovaYUniver2",
        specialty: "oripovaYSpec2",
      },
      {
        id: uuidv4(),
        univer: "oripovaYUniver3",
        specialty: "oripovaYSpec3",
      },
      {
        id: uuidv4(),
        univer: "oripovaYUniver4",
        specialty: "oripovaYSpec4",
      },
    ],
    experience: ["oripovaYDegree1", "oripovaYDegree2"],
    awards: ["oripovaYAward1"],
  },
  {
    id: 7,
    img: eshniyozovZarifjonIMG,
    imagePosition: "top 18%",
    imageScale: 1.1,
    name: "eshniyozovZarifName",
    specialist: "eshniyozovZarifSpec",
    socials: {
      facebook: "https://www.facebook.com/",
      instagram: "https://www.instagram.com/",
      twitter: "https://x.com/",
      telegram: "https://telegram.org/",
    },
    bio: "eshniyozovZarifBio",
    contact: {
      phone: "+998 (95) 410 00 14",
      mail: "test@gmail.com",
    },
    schedules: [
      {
        id: uuidv4(),
        title: "monday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "tuesday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "wednesday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "thursday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "friday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "saturday",
        time: "09.00-12.00",
      },
    ],
    degrees: [
      {
        id: uuidv4(),
        univer: "eshniyozovZarifUniver1",
        specialty: "eshniyozovZarifSpec1",
      },
      {
        id: uuidv4(),
        univer: "eshniyozovZarifUniver2",
        specialty: "eshniyozovZarifSpec2",
      },
      {
        id: uuidv4(),
        univer: "eshniyozovZarifUniver3",
        specialty: "eshniyozovZarifSpec3",
      },
      {
        id: uuidv4(),
        univer: "eshniyozovZarifUniver4",
        specialty: "eshniyozovZarifSpec4",
      },
    ],
    experience: ["eshniyozovZarifDegree1", "eshniyozovZarifDegree2"],
    awards: ["eshniyozovZarifAward1", "eshniyozovZarifAward2"],
  },
  {
    id: 8,
    img: xasanovJasurIMG,
    imagePosition: "center 16%",
    imageScale: 1,
    name: "xasanovJasurName",
    specialist: "xasanovJasurSpec",
    socials: {
      facebook: "https://www.facebook.com/",
      instagram: "https://www.instagram.com/",
      twitter: "https://x.com/",
      telegram: "https://telegram.org/",
    },
    bio: "xasanovJasurBio",
    contact: {
      phone: "+998 (95) 410 00 14",
      mail: "test@gmail.com",
    },
    schedules: [
      {
        id: uuidv4(),
        title: "monday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "tuesday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "wednesday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "thursday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "friday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "saturday",
        time: "09.00-12.00",
      },
    ],
    degrees: [
      {
        id: uuidv4(),
        univer: "xasanovJasurUniver1",
        specialty: "xasanovJasurSpec1",
      },
      {
        id: uuidv4(),
        univer: "xasanovJasurUniver2",
        specialty: "xasanovJasurSpec2",
      },
      {
        id: uuidv4(),
        univer: "xasanovJasurUniver3",
        specialty: "xasanovJasurSpec3",
      },
    ],
    experience: ["xasanovJasurDegree1", "xasanovJasurDegree2"],
    awards: ["xasanovJasurAward1"],
  },
  {
    id: 9,
    img: ibodullayevBektoshIMG,
    imagePosition: "center 16%",
    imageScale: 1,
    name: "ibodullayevBektoshName",
    specialist: "ibodullayevBektoshSpec",
    socials: {
      facebook: "https://www.facebook.com/",
      instagram: "https://www.instagram.com/",
      twitter: "https://x.com/",
      telegram: "https://telegram.org/",
    },
    bio: "ibodullayevBektoshBio",
    contact: {
      phone: "+998 (95) 410 00 14",
      mail: "test@gmail.com",
    },
    schedules: [
      {
        id: uuidv4(),
        title: "monday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "tuesday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "wednesday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "thursday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "friday",
        time: "09.00-12.00",
      },
      {
        id: uuidv4(),
        title: "saturday",
        time: "09.00-12.00",
      },
    ],
    degrees: [
      {
        id: uuidv4(),
        univer: "ibodullayevBektoshUniver1",
        specialty: "ibodullayevBektoshSpec1",
      },
      {
        id: uuidv4(),
        univer: "ibodullayevBektoshUniver2",
        specialty: "ibodullayevBektoshSpec2",
      },
      {
        id: uuidv4(),
        univer: "ibodullayevBektoshUniver3",
        specialty: "ibodullayevBektoshSpec3",
      },
    ],
    experience: ["ibodullayevBektoshDegree1"],
    awards: ["ibodullayevBektoshAward1", "ibodullayevBektoshAward2"],
  },
];

export default list.sort((doctorA, doctorB) => doctorA.id - doctorB.id);
